import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Loading from './ui/loading';

interface Props {
  children: React.ReactNode;
}

const RequireAdmin: React.FC<Props> = ({ children }) => {
  const { user, loading, isAuthenticated } = useAuth();
  const location = useLocation();

  console.log('🔍 RequireAdmin Debug - Component rendered');
  console.log('🔍 RequireAdmin Debug - Loading:', loading);
  console.log('🔍 RequireAdmin Debug - Is authenticated:', isAuthenticated);
  console.log('🔍 RequireAdmin Debug - User object:', user);
  console.log('🔍 RequireAdmin Debug - Location:', location.pathname);

  // Show loading state while checking authentication
  if (loading) {
    console.log('🔍 RequireAdmin Debug - Showing loading state');
    return <Loading text="Checking authentication..." fullScreen />;
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated || !user) {
    console.log('🔍 RequireAdmin Debug - Not authenticated, redirecting to login');
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Get user role - handle both JWT payload and full user object
  const userRole = user.roleName || user.role?.name || null;
  
  console.log('🔍 RequireAdmin Debug - User role:', userRole);

  const hasAdminRole = userRole === 'admin' || userRole === 'super_admin';

  console.log('🔍 RequireAdmin Debug - Has admin role:', hasAdminRole);

  // Basic admin check
  if (!hasAdminRole) {
    console.log('🔍 RequireAdmin Debug - No admin role found, redirecting to unauthorized');
    return <Navigate to="/unauthorized" replace />;
  }

  // Additional permission check for admin management page
  if (location.pathname === '/admin') {
    const hasSuperAdminRole = userRole === 'super_admin';
    
    if (!hasSuperAdminRole) {
      console.log('🔍 RequireAdmin Debug - Admin access denied to super admin page, redirecting to dashboard');
      return <Navigate to="/dashboard" replace />;
    }
  }

  console.log('🔍 RequireAdmin Debug - Admin access granted');
  return <>{children}</>;
};

export default RequireAdmin;
